import i18n from '@/i18n';
import { validateEmail, validateEAN, validateOptionalAddress } from '@/utils/validate';

export function validatorEmail(rule, value, callback) {
  if (value && !validateEmail(value)) {
    callback(new Error(i18n.t('validation.email')));
  } else {
    callback();
  }
}
export function validatorRequiredObject(rule, value, callback) {
  if (Object.keys(value) === 0 || !Object.values(value).some(v => v > 0)) {
    callback(new Error(i18n.t('validation.required')));
  } else {
    callback();
  }
}
export function validatorRequireNumber(rule, value, callback) {
  if ((value !== 0 && !value) || value.length === 0) {
    callback(new Error(i18n.t('validation.required')));
  } else {
    callback();
  }
}
export function validatorRequire(rule, value, callback) {
  if (!value || value.length === 0) {
    callback(new Error(i18n.t('validation.required')));
  } else {
    callback();
  }
}
export function validatorHasValue(rule, value, callback) {
  const hasValue = value !== null && value !== undefined;
  if (!hasValue) {
    callback(new Error(i18n.t('validation.required')));
  } else {
    callback();
  }
}
export const validatorConditionalHasValue = (conditionalValue, errorMessage) => (rule, value, callback) => {
  const hasValue = value !== null && value !== undefined;
  if (!!conditionalValue && !hasValue) {
    callback(new Error(i18n.t(errorMessage || 'validation.required')));
  } else {
    callback();
  }
};
export function validatorRequiredRating(rule, value, callback) {
  if (!(value >= 1 && value <= 5)) {
    callback(new Error(i18n.t('validation.complexity')));
  } else {
    callback();
  }
}

export function validatorRequireMultipleSelect(rule, value, callback) {
  if (value.length === 0) {
    callback(new Error(i18n.t('validation.required')));
  } else {
    callback();
  }
}

export const validatorUnique = (existingValues, errorMessage) => (rule, value, callback) => {
  if (existingValues.some(excluded => excluded === value)) {
    callback(new Error(i18n.t(errorMessage || 'validation.unique')));
  } else {
    callback();
  }
};
export const validatorConditionalRequired = (conditionalValue, errorMessage) => (rule, value, callback) => {
  if (!!conditionalValue && (!value || value.length === 0)) {
    callback(new Error(i18n.t(errorMessage || 'validation.required')));
  } else {
    callback();
  }
};

export const validatorConditionalRequiredNumber = (conditionalValue, errorMessage) => (rule, value, callback) => {
  if (!!conditionalValue && ((value !== 0 && !value) || value.length === 0)) {
    callback(new Error(i18n.t(errorMessage || 'validation.required')));
  } else {
    callback();
  }
};

export const validatorOptionalAddress = (rule, value, callback) => {
  if (!validateOptionalAddress(value)) {
    callback(new Error(' ')); // Error message is displayed in component
  } else {
    callback();
  }
};

export function validatorEAN(rule, value, callback) {
  if (value !== null && value.length > 0 && !validateEAN(value)) {
    callback(new Error(i18n.t('validation.ean')));
  } else {
    callback();
  }
}
